import { useMemo, useState } from 'react';
import { Owner } from 'types';

type Step = 'Step 1' | 'Step 2' | 'Step 3';

export const useCreateSafe = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStep, setSelectedStep] = useState<Step>('Step 1');
  const [safeName, setSafeName] = useState('');
  const [owners, setOwners] = useState<Owner[]>([]);
  const [confirmationThreshold, setConfirmationThreshold] = useState(1);
  const [createSafeError, setCreateSafeError] = useState('');

  return useMemo(
    () => ({
      isLoading,
      setIsLoading,
      selectedStep,
      setSelectedStep,
      safeName,
      setSafeName,
      owners,
      setOwners,
      confirmationThreshold,
      setConfirmationThreshold,
      createSafeError,
      setCreateSafeError,
    }),
    [isLoading, selectedStep, safeName, owners, confirmationThreshold, createSafeError]
  );
};
